/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {DeadwoodGameMode} from "../../gamemode/DeadwoodGameMode";
import {DeadwoodServerDataParser} from "../DeadwoodServerDataParser";
import {IDeadwoodParsedServerData} from "./IDeadwoodParsedServerData";
import {IDeadwoodInitData} from "./IDeadwoodServerData";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {DeadwoodGameModuleConfig} from "../../DeadwoodGameModuleConfig";

export class DeadwoodParsedInitData extends ParsedInitData implements IDeadwoodParsedServerData {
    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    private readonly _multiplierOnReel:number[];
    public get multiplierOnReel():number[] {
        return this._multiplierOnReel;
    }

    private readonly _bonusTriggeredThisSpin:boolean;
    public get bonusTriggeredThisSpin():boolean {
        return this._bonusTriggeredThisSpin;
    }

    private readonly _bonusPositions:number[];
    public get bonusPositions():number[] {
        return this._bonusPositions;
    }

    private readonly _fsSuperModeActive:boolean;
    public get fsSuperModeActive():boolean {
        return this._fsSuperModeActive;
    }

    private readonly _playerFSSelection:number;
    public get playerFSSelection():number {
        return this._playerFSSelection;
    }

    private readonly _numberOfSpinsFreespin:[number, number];
    public get numberOfSpinsFreespin():[number, number] {
        return this._numberOfSpinsFreespin;
    }

    private readonly _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    private readonly _accumulatedRoundWin:string;

    constructor(rawData:IDeadwoodInitData, dataParser:DeadwoodServerDataParser) {
        super(rawData, dataParser);
        DeadwoodGameModuleConfig.isRestore=rawData.isRestoreState;
        this._multiplierOnReel = dataParser.parseMultiplierOnReel(rawData);
        this._bonusTriggeredThisSpin = dataParser.parseBonusTriggeredThisSpin(rawData);
        this._bonusPositions = dataParser.parseBonusPositions(rawData);
        this._fsSuperModeActive = dataParser.parseFsSuperModeActive(rawData);
        this._playerFSSelection = dataParser.parsePlayerFSSelection(rawData);
        this._numberOfSpinsFreespin = dataParser.parseNumberOfSpinsFreespin(rawData);
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    protected isFeatureTotalWin(rawData:IServerData):boolean {
        return this.mode === DeadwoodGameMode.FREESPIN_GUNSLINGER || this.mode === DeadwoodGameMode.FREESPIN_HUNTERS;
    }

    protected isNextFeatureTotalWin(rawData:IServerData):boolean {
        return this.nextMode === DeadwoodGameMode.FREESPIN_GUNSLINGER || this.nextMode === DeadwoodGameMode.FREESPIN_HUNTERS;
    }
}